
import {
    addCheckProjectGroup,
    editCheckProjectGroup,
    carCheckProjectList,
    getCheckProjectGroup,
    getCarCheckArray, carCheckchangeStatus
} from "@/api/http";

const columnList: Array<any> = [
    {
        prop: "name",
        label: "名称",
        width: 100,
    }
]

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch
} from "vue";
import {Request} from "../../api/request";
export default {
    name: "carcheckgroup",
    setup(){
        const setTitle: any = inject("setTitle");
        setTitle(["检车分组"]);
        let tableData = ref([]),
            loading = ref(true),
            headClass = inject("headClass"),
            total = ref(0),
            dialog_show = ref(''),
            form = reactive({
                name:'',
                id:'',
                projects:[]
            }),
            originalArray = ref([]),
            formRef = ref(null),
            pageSize = ref(10),
            currentPage = ref(1);
        let getTableData = (): void => {
                loading.value = true;
                let data = {
                    page:currentPage.value,
                    pagesize:pageSize.value
                }
                getCheckProjectGroup(data).then((res:any)=>{
                    tableData.value = res?.content?.list || [];
                    total.value = res?.content.total;
                    loading.value = false;
                });
            
            },
            getCarCheckProjects = ()=> {
                carCheckProjectList({}).then((res:any)=>{
                    form.projects = res.content;
                    originalArray.value = res.content;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            addClick = ()=>{
                if(formRef.value){
                    (formRef.value as any).resetFields();
                }
                dialog_show.value = 'add';
                form.name = '';
                form.id = '';
                //form.projects = originalArray.value;
                form.projects = JSON.parse(JSON.stringify(originalArray.value));
            },
            _submitForm = ()=>{
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid){
                        if (dialog_show.value == 'add'){
                            addCheckProjectGroup({...form}).then((res:any)=>{
                                dialog_show.value = '';
                            });
                        } else {
                            editCheckProjectGroup({...form}).then((res:any)=>{
                                dialog_show.value = '';
                            });
                        }
                        currentPage.value = 1;
                        getTableData();
                    }
                });
            },
            editClick = (item:any)=>{
                getCarCheckArray({id:item.id}).then((res:any)=>{
                    dialog_show.value = 'edit';
                    form.name = item.name;
                    form.id = item.id;
                    form.projects = res.content;
                });
                
            },
            deleteClick = (item:any)=>{
                carCheckchangeStatus({id:item.id}).then(()=>{
                    getTableData();
                });
            },
            _upState = (id:number)=>{
            
            };
        onMounted(() => {
            getCarCheckProjects();
            getTableData()
        });
        return{
            columnList,
            tableData,
            loading,
            headClass,
            pageSize,
            currentPage,
            getTableData,
            _upState,
            handleSizeChange,
            handleCurrentChange,
            total,
            dialog_show,
            form,
            addClick,
            _submitForm,
            formRef,
            editClick,
            deleteClick
        }
    }
}
